// Static translation bindings: user-entered and stored data remain untouched.
import {localize,localizeRich,localizedDictionary} from "../i18n/runtime";
import {Navigate} from "react-router-dom";
import {useAuth} from "../lib/auth";
import AtlasPublic from './AtlasPublic';
export default function EntryRoute() {
  const {user,loading}=useAuth();
  if(loading)return <div role="status" aria-label={localize("ui.4959bc37c4c52ad5","Loading")} className="min-h-screen" style={{background:"#041019"}}/>;
  return user?<Navigate to="/praxis-tool/home" replace/>:<AtlasPublic/>;
}

